import axios from 'axios';
import { APP_API_PATH } from 'config';
import { dispatch } from 'store';
import { setWebVersion } from 'store/reducers/web-version';

const axiosServices = axios.create({
  baseURL:APP_API_PATH,
});

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosServices.interceptors.response.use(
  (response) => {
      // if(localStorage.getItem("server_version") !== response.headers["x-web-version"]){
      //   localStorage.setItem("server_version", response.headers["x-web-version"]);
      // }
const version = response.headers['x-web-version'];
    if (version) {
      dispatch(setWebVersion(version));
    }
      
    return response;
  },
  (error) => Promise.reject((error.response && error.response.data) || 'Wrong Services')
);

export default axiosServices;
